import {combineReducers} from 'redux';

import examples from './example.reducer';

const exampleAppReducer = combineReducers({
    examples
});

export default exampleAppReducer;



// WEBPACK FOOTER //
// src/main/content/example/store/reducers/index.js